
URL = globalThis.URL
import __vite__wasmUrl from "/home/runner/work/yap/yap/yap-frontend-rs/pkg/yap_frontend_rs_bg.wasm?url"
import __vite__initWasm from "/__vite-plugin-wasm-helper"
import * as __vite__wasmImport_0 from "./yap_frontend_rs_bg.js";
const __vite__wasmModule = await __vite__initWasm({ "./yap_frontend_rs_bg.js": { "__wbg_deck_new": __vite__wasmImport_0["__wbg_deck_new"],
"__wbg_weapon_new": __vite__wasmImport_0["__wbg_weapon_new"],
"__wbg_clipresult_new": __vite__wasmImport_0["__wbg_clipresult_new"],
"__wbg_audioresult_new": __vite__wasmImport_0["__wbg_audioresult_new"],
"__wbg_lockupoffer_new": __vite__wasmImport_0["__wbg_lockupoffer_new"],
"__wbg_releaseoffer_new": __vite__wasmImport_0["__wbg_releaseoffer_new"],
"__wbg_dictionaryword_new": __vite__wasmImport_0["__wbg_dictionaryword_new"],
"__wbg_new_6a349535e20799b9": __vite__wasmImport_0["__wbg_new_6a349535e20799b9"],
"__wbg_new_typed_bf31d18f92484486": __vite__wasmImport_0["__wbg_new_typed_bf31d18f92484486"],
"__wbg_then_18f476d590e58992": __vite__wasmImport_0["__wbg_then_18f476d590e58992"],
"__wbg_call_9c758de292015997": __vite__wasmImport_0["__wbg_call_9c758de292015997"],
"__wbg_call_40e4174f169eaca7": __vite__wasmImport_0["__wbg_call_40e4174f169eaca7"],
"__wbg_next_fe4491d95e72b54d": __vite__wasmImport_0["__wbg_next_fe4491d95e72b54d"],
"__wbg_randomUUID_04ea01e1c13ecfa1": __vite__wasmImport_0["__wbg_randomUUID_04ea01e1c13ecfa1"],
"__wbg_listenerkey_new": __vite__wasmImport_0["__wbg_listenerkey_new"],
"__wbg_listenerkey_unwrap": __vite__wasmImport_0["__wbg_listenerkey_unwrap"],
"__wbg_catch_17ae9c6dfb88ad8a": __vite__wasmImport_0["__wbg_catch_17ae9c6dfb88ad8a"],
"__wbg_new_b682b81e8eaaf027": __vite__wasmImport_0["__wbg_new_b682b81e8eaaf027"],
"__wbg_set_52b1e1eb5bed906a": __vite__wasmImport_0["__wbg_set_52b1e1eb5bed906a"],
"__wbg_push_a6822215aa43e71c": __vite__wasmImport_0["__wbg_push_a6822215aa43e71c"],
"__wbg_instanceof_Map_9fc06d9a951bcee6": __vite__wasmImport_0["__wbg_instanceof_Map_9fc06d9a951bcee6"],
"__wbg_set_dca99999bba88a9a": __vite__wasmImport_0["__wbg_set_dca99999bba88a9a"],
"__wbg_get_unchecked_33f6e5c9e2f2d6b2": __vite__wasmImport_0["__wbg_get_unchecked_33f6e5c9e2f2d6b2"],
"__wbg_next_eb8ca7351fa27906": __vite__wasmImport_0["__wbg_next_eb8ca7351fa27906"],
"__wbg_done_60cf307fcc680536": __vite__wasmImport_0["__wbg_done_60cf307fcc680536"],
"__wbg_value_f3625092ee4b37f4": __vite__wasmImport_0["__wbg_value_f3625092ee4b37f4"],
"__wbg_length_66f1a4b2e9026940": __vite__wasmImport_0["__wbg_length_66f1a4b2e9026940"],
"__wbg_deref_4e4220ad43c8ba63": __vite__wasmImport_0["__wbg_deref_4e4220ad43c8ba63"],
"__wbg_get_2b48c7d0d006a781": __vite__wasmImport_0["__wbg_get_2b48c7d0d006a781"],
"__wbg_get_with_ref_key_6412cf3094599694": __vite__wasmImport_0["__wbg_get_with_ref_key_6412cf3094599694"],
"__wbg_set_6be42768c690e380": __vite__wasmImport_0["__wbg_set_6be42768c690e380"],
"__wbg_String_8564e559799eccda": __vite__wasmImport_0["__wbg_String_8564e559799eccda"],
"__wbg_new_227d7c05414eb861": __vite__wasmImport_0["__wbg_new_227d7c05414eb861"],
"__wbg_stack_3b0d974bbf31e44f": __vite__wasmImport_0["__wbg_stack_3b0d974bbf31e44f"],
"__wbg_error_a6fa202b58aa1cd3": __vite__wasmImport_0["__wbg_error_a6fa202b58aa1cd3"],
"__wbg_setTimeout_ef24d2fc3ad97385": __vite__wasmImport_0["__wbg_setTimeout_ef24d2fc3ad97385"],
"__wbg_clearTimeout_113b1cde814ec762": __vite__wasmImport_0["__wbg_clearTimeout_113b1cde814ec762"],
"__wbg_performance_3fcf6e32a7e1ed0a": __vite__wasmImport_0["__wbg_performance_3fcf6e32a7e1ed0a"],
"__wbg_now_e7c6795a7f81e10f": __vite__wasmImport_0["__wbg_now_e7c6795a7f81e10f"],
"__wbg_instanceof_Window_e093be59ee9a8e14": __vite__wasmImport_0["__wbg_instanceof_Window_e093be59ee9a8e14"],
"__wbg_fetch_ce1af4d1b59a60be": __vite__wasmImport_0["__wbg_fetch_ce1af4d1b59a60be"],
"__wbg_navigator_3833ecdbc19d2757": __vite__wasmImport_0["__wbg_navigator_3833ecdbc19d2757"],
"__wbg_log_d5e0f90a3ac097e3": __vite__wasmImport_0["__wbg_log_d5e0f90a3ac097e3"],
"__wbg_info_5cfb3f6c22c53cf9": __vite__wasmImport_0["__wbg_info_5cfb3f6c22c53cf9"],
"__wbg_warn_c49a7a9581bf8bea": __vite__wasmImport_0["__wbg_warn_c49a7a9581bf8bea"],
"__wbg_debug_6d96d354ecb8cdb3": __vite__wasmImport_0["__wbg_debug_6d96d354ecb8cdb3"],
"__wbg_error_78ff5b3a29b770e0": __vite__wasmImport_0["__wbg_error_78ff5b3a29b770e0"],
"__wbg_error_9ad1450feb5d541d": __vite__wasmImport_0["__wbg_error_9ad1450feb5d541d"],
"__wbg_set_25ef40a9aeff260d": __vite__wasmImport_0["__wbg_set_25ef40a9aeff260d"],
"__wbg_getReader_186390151a19bc55": __vite__wasmImport_0["__wbg_getReader_186390151a19bc55"],
"__wbg_instanceof_FileSystemFileHandle_6290c6738a00655e": __vite__wasmImport_0["__wbg_instanceof_FileSystemFileHandle_6290c6738a00655e"],
"__wbg_createWritable_c0ea35f4b8856093": __vite__wasmImport_0["__wbg_createWritable_c0ea35f4b8856093"],
"__wbg_getFile_57f23539bd8b1536": __vite__wasmImport_0["__wbg_getFile_57f23539bd8b1536"],
"__wbg_set_capture_470b54e0a5c98d83": __vite__wasmImport_0["__wbg_set_capture_470b54e0a5c98d83"],
"__wbg_set_passive_cd1f03dae3bdd0f9": __vite__wasmImport_0["__wbg_set_passive_cd1f03dae3bdd0f9"],
"__wbg_set_once_27df5233613a51cd": __vite__wasmImport_0["__wbg_set_once_27df5233613a51cd"],
"__wbg_instanceof_FileSystemDirectoryHandle_527d4a4ebcd0f631": __vite__wasmImport_0["__wbg_instanceof_FileSystemDirectoryHandle_527d4a4ebcd0f631"],
"__wbg_removeEntry_e4b1351d33d6ed6e": __vite__wasmImport_0["__wbg_removeEntry_e4b1351d33d6ed6e"],
"__wbg_removeEntry_8c83cbf5446bf554": __vite__wasmImport_0["__wbg_removeEntry_8c83cbf5446bf554"],
"__wbg_getFileHandle_1bfaf7268935b051": __vite__wasmImport_0["__wbg_getFileHandle_1bfaf7268935b051"],
"__wbg_getDirectoryHandle_1074878dbbebce4d": __vite__wasmImport_0["__wbg_getDirectoryHandle_1074878dbbebce4d"],
"__wbg_entries_c4d0a7d1625aea7f": __vite__wasmImport_0["__wbg_entries_c4d0a7d1625aea7f"],
"__wbg_set_keep_existing_data_3f5c76813ab5e1ba": __vite__wasmImport_0["__wbg_set_keep_existing_data_3f5c76813ab5e1ba"],
"__wbg_new_with_str_and_init_bcd02b79a793d27f": __vite__wasmImport_0["__wbg_new_with_str_and_init_bcd02b79a793d27f"],
"__wbg_headers_d94793faa2079ffa": __vite__wasmImport_0["__wbg_headers_d94793faa2079ffa"],
"__wbg_set_method_7a6811dec7a4feff": __vite__wasmImport_0["__wbg_set_method_7a6811dec7a4feff"],
"__wbg_set_signal_d9da62b3f215c821": __vite__wasmImport_0["__wbg_set_signal_d9da62b3f215c821"],
"__wbg_set_body_36614c7e61546809": __vite__wasmImport_0["__wbg_set_body_36614c7e61546809"],
"__wbg_set_mode_c90e3667002857d4": __vite__wasmImport_0["__wbg_set_mode_c90e3667002857d4"],
"__wbg_getDirectory_81f0c16f73a7f542": __vite__wasmImport_0["__wbg_getDirectory_81f0c16f73a7f542"],
"__wbg_new_0d09705104e164af": __vite__wasmImport_0["__wbg_new_0d09705104e164af"],
"__wbg_abort_2ec46222bf378517": __vite__wasmImport_0["__wbg_abort_2ec46222bf378517"],
"__wbg_signal_e03304a84df9ed09": __vite__wasmImport_0["__wbg_signal_e03304a84df9ed09"],
"__wbg_set_recursive_8ba27b0bc5f813e8": __vite__wasmImport_0["__wbg_set_recursive_8ba27b0bc5f813e8"],
"__wbg_set_create_7f95adb9ce7dde2a": __vite__wasmImport_0["__wbg_set_create_7f95adb9ce7dde2a"],
"__wbg_seek_d9a86a0fbd023a65": __vite__wasmImport_0["__wbg_seek_d9a86a0fbd023a65"],
"__wbg_write_d396c20c2e70d187": __vite__wasmImport_0["__wbg_write_d396c20c2e70d187"],
"__wbg_truncate_9922676e99063a88": __vite__wasmImport_0["__wbg_truncate_9922676e99063a88"],
"__wbg_set_create_99030ba72d3faa4e": __vite__wasmImport_0["__wbg_set_create_99030ba72d3faa4e"],
"__wbg_storage_3f560ba25b19525f": __vite__wasmImport_0["__wbg_storage_3f560ba25b19525f"],
"__wbg_arrayBuffer_a0e88fd0c0e099b2": __vite__wasmImport_0["__wbg_arrayBuffer_a0e88fd0c0e099b2"],
"__wbg_size_9970092b88b1094c": __vite__wasmImport_0["__wbg_size_9970092b88b1094c"],
"__wbg_instanceof_Response_cb984bd66d7bd408": __vite__wasmImport_0["__wbg_instanceof_Response_cb984bd66d7bd408"],
"__wbg_arrayBuffer_05927079aabe6d46": __vite__wasmImport_0["__wbg_arrayBuffer_05927079aabe6d46"],
"__wbg_ok_fb13c30bc1893039": __vite__wasmImport_0["__wbg_ok_fb13c30bc1893039"],
"__wbg_body_61a0827da5b6d2bc": __vite__wasmImport_0["__wbg_body_61a0827da5b6d2bc"],
"__wbg_text_a17febec76d36501": __vite__wasmImport_0["__wbg_text_a17febec76d36501"],
"__wbg_status_00549d55b78d949e": __vite__wasmImport_0["__wbg_status_00549d55b78d949e"],
"__wbg_removeEventListener_9e2e49dbe3ca4858": __vite__wasmImport_0["__wbg_removeEventListener_9e2e49dbe3ca4858"],
"__wbg_addEventListener_5593b0efd622abd6": __vite__wasmImport_0["__wbg_addEventListener_5593b0efd622abd6"],
"__wbg_instanceof_ReadableStreamDefaultReader_7d8cc44877a9f6ef": __vite__wasmImport_0["__wbg_instanceof_ReadableStreamDefaultReader_7d8cc44877a9f6ef"],
"__wbg_read_282e152a24fd0856": __vite__wasmImport_0["__wbg_read_282e152a24fd0856"],
"__wbg_aborted_3bd851834eb1ecce": __vite__wasmImport_0["__wbg_aborted_3bd851834eb1ecce"],
"__wbg_instanceof_AbortSignal_62ae3458aa4f4cc6": __vite__wasmImport_0["__wbg_instanceof_AbortSignal_62ae3458aa4f4cc6"],
"__wbg_request_9ec6302d6583b381": __vite__wasmImport_0["__wbg_request_9ec6302d6583b381"],
"__wbg_close_3a6bb6c95fcc0a4a": __vite__wasmImport_0["__wbg_close_3a6bb6c95fcc0a4a"],
"__wbg_postMessage_78111ac355397c0c": __vite__wasmImport_0["__wbg_postMessage_78111ac355397c0c"],
"__wbg_new_f6da38a590760568": __vite__wasmImport_0["__wbg_new_f6da38a590760568"],
"__wbg_close_005f131e35bfd850": __vite__wasmImport_0["__wbg_close_005f131e35bfd850"],
"__wbg_new_with_u8_array_sequence_2cd9a3f01fcff785": __vite__wasmImport_0["__wbg_new_with_u8_array_sequence_2cd9a3f01fcff785"],
"__wbg_new_622fc80556be2e26": __vite__wasmImport_0["__wbg_new_622fc80556be2e26"],
"__wbg_new_d90091b82fdf5b91": __vite__wasmImport_0["__wbg_new_d90091b82fdf5b91"],
"__wbg_new_ce1ab61c1c2b300d": __vite__wasmImport_0["__wbg_new_ce1ab61c1c2b300d"],
"__wbg_new_578aeef4b6b94378": __vite__wasmImport_0["__wbg_new_578aeef4b6b94378"],
"__wbg_length_4a591ecaa01354d9": __vite__wasmImport_0["__wbg_length_4a591ecaa01354d9"],
"__wbg_new_from_slice_18fa1f71286d66b8": __vite__wasmImport_0["__wbg_new_from_slice_18fa1f71286d66b8"],
"__wbg_new_with_length_36a4998e27b014c5": __vite__wasmImport_0["__wbg_new_with_length_36a4998e27b014c5"],
"__wbg_prototypesetcall_3249fc62a0fafa30": __vite__wasmImport_0["__wbg_prototypesetcall_3249fc62a0fafa30"],
"__wbg_set_index_73ced2e1b4a2a37e": __vite__wasmImport_0["__wbg_set_index_73ced2e1b4a2a37e"],
"__wbg_isView_7196124a1d67a99a": __vite__wasmImport_0["__wbg_isView_7196124a1d67a99a"],
"__wbg_then_ac7b025999b52837": __vite__wasmImport_0["__wbg_then_ac7b025999b52837"],
"__wbg_call_8a89609d89f6608a": __vite__wasmImport_0["__wbg_call_8a89609d89f6608a"],
"__wbg_instanceof_Error_94c8c9d9e410014a": __vite__wasmImport_0["__wbg_instanceof_Error_94c8c9d9e410014a"],
"__wbg_instanceof_Uint8Array_86f30649f63ef9c2": __vite__wasmImport_0["__wbg_instanceof_Uint8Array_86f30649f63ef9c2"],
"__wbg_instanceof_ArrayBuffer_8f49811467741499": __vite__wasmImport_0["__wbg_instanceof_ArrayBuffer_8f49811467741499"],
"__wbg_new_69240efb3ceaa732": __vite__wasmImport_0["__wbg_new_69240efb3ceaa732"],
"__wbg_register_2b38856410c0745e": __vite__wasmImport_0["__wbg_register_2b38856410c0745e"],
"__wbg_getTimezoneOffset_08e2892156231088": __vite__wasmImport_0["__wbg_getTimezoneOffset_08e2892156231088"],
"__wbg_new_0_445c13a750296eb6": __vite__wasmImport_0["__wbg_new_0_445c13a750296eb6"],
"__wbg_getTime_00b3f7db575e4ef5": __vite__wasmImport_0["__wbg_getTime_00b3f7db575e4ef5"],
"__wbg_from_d300fe49deab18f5": __vite__wasmImport_0["__wbg_from_d300fe49deab18f5"],
"__wbg_isArray_67c2c9c4313f4448": __vite__wasmImport_0["__wbg_isArray_67c2c9c4313f4448"],
"__wbg_new_50bb5ebeecef71a8": __vite__wasmImport_0["__wbg_new_50bb5ebeecef71a8"],
"__wbg_name_2e3d97e5d7abee6d": __vite__wasmImport_0["__wbg_name_2e3d97e5d7abee6d"],
"__wbg_isSafeInteger_66acec27e09e99a7": __vite__wasmImport_0["__wbg_isSafeInteger_66acec27e09e99a7"],
"__wbg_entries_04b37a02507f1713": __vite__wasmImport_0["__wbg_entries_04b37a02507f1713"],
"__wbg_iterator_8732428d309e270e": __vite__wasmImport_0["__wbg_iterator_8732428d309e270e"],
"__wbg_static_accessor_GLOBAL_THIS_a1a35cec07001a8a": __vite__wasmImport_0["__wbg_static_accessor_GLOBAL_THIS_a1a35cec07001a8a"],
"__wbg_static_accessor_SELF_4c59f6c7ea29a144": __vite__wasmImport_0["__wbg_static_accessor_SELF_4c59f6c7ea29a144"],
"__wbg_static_accessor_GLOBAL_9d53f2689e622ca1": __vite__wasmImport_0["__wbg_static_accessor_GLOBAL_9d53f2689e622ca1"],
"__wbg_static_accessor_WINDOW_e70ae9f2eb052253": __vite__wasmImport_0["__wbg_static_accessor_WINDOW_e70ae9f2eb052253"],
"__wbg_resolve_25a7e548d5881dca": __vite__wasmImport_0["__wbg_resolve_25a7e548d5881dca"],
"__wbg_next_9e03acdf51c4960d": __vite__wasmImport_0["__wbg_next_9e03acdf51c4960d"],
"__wbg_get_1f8f054ddbaa7db2": __vite__wasmImport_0["__wbg_get_1f8f054ddbaa7db2"],
"__wbg_get_de6a0f7d4d18a304": __vite__wasmImport_0["__wbg_get_de6a0f7d4d18a304"],
"__wbg_set_6e30c9374c26414c": __vite__wasmImport_0["__wbg_set_6e30c9374c26414c"],
"__wbg_queueMicrotask_35c611f4a14830b2": __vite__wasmImport_0["__wbg_queueMicrotask_35c611f4a14830b2"],
"__wbg_queueMicrotask_404ed0a58e0b63cc": __vite__wasmImport_0["__wbg_queueMicrotask_404ed0a58e0b63cc"],
"__wbg___wbindgen_number_get_9bb1761122181af2": __vite__wasmImport_0["__wbg___wbindgen_number_get_9bb1761122181af2"],
"__wbg___wbindgen_in_70a403a56e771704": __vite__wasmImport_0["__wbg___wbindgen_in_70a403a56e771704"],
"__wbg___wbindgen_throw_1506f2235d1bdba0": __vite__wasmImport_0["__wbg___wbindgen_throw_1506f2235d1bdba0"],
"__wbg___wbindgen_is_null_87c3bfe968c6a5ad": __vite__wasmImport_0["__wbg___wbindgen_is_null_87c3bfe968c6a5ad"],
"__wbg___wbindgen_jsval_eq_1068e624fa87f6ab": __vite__wasmImport_0["__wbg___wbindgen_jsval_eq_1068e624fa87f6ab"],
"__wbg_Number_6b506e6536831eaa": __vite__wasmImport_0["__wbg_Number_6b506e6536831eaa"],
"__wbg_Error_ef53bc310eb298a0": __vite__wasmImport_0["__wbg_Error_ef53bc310eb298a0"],
"__wbg___wbindgen_is_bigint_6ffd6468a9bc44b9": __vite__wasmImport_0["__wbg___wbindgen_is_bigint_6ffd6468a9bc44b9"],
"__wbg___wbindgen_is_object_56732c2bc353f41d": __vite__wasmImport_0["__wbg___wbindgen_is_object_56732c2bc353f41d"],
"__wbg___wbindgen_is_string_c236cabd84a4d769": __vite__wasmImport_0["__wbg___wbindgen_is_string_c236cabd84a4d769"],
"__wbg___wbindgen_string_get_72bdf95d3ae505b1": __vite__wasmImport_0["__wbg___wbindgen_string_get_72bdf95d3ae505b1"],
"__wbg___wbindgen_boolean_get_1a45e2c38d4d41b9": __vite__wasmImport_0["__wbg___wbindgen_boolean_get_1a45e2c38d4d41b9"],
"__wbg___wbindgen_is_function_754e9f305ff6029e": __vite__wasmImport_0["__wbg___wbindgen_is_function_754e9f305ff6029e"],
"__wbg___wbindgen_is_undefined_67b456be8673d3d7": __vite__wasmImport_0["__wbg___wbindgen_is_undefined_67b456be8673d3d7"],
"__wbg___wbindgen_jsval_loose_eq_2c56564c75129511": __vite__wasmImport_0["__wbg___wbindgen_jsval_loose_eq_2c56564c75129511"],
"__wbg___wbindgen_bigint_get_as_i64_38130e98eecd467d": __vite__wasmImport_0["__wbg___wbindgen_bigint_get_as_i64_38130e98eecd467d"],
"__wbg___wbindgen_debug_string_0accd80f45e5faa2": __vite__wasmImport_0["__wbg___wbindgen_debug_string_0accd80f45e5faa2"],
"__wbg__wbg_cb_unref_61db23ac97f16c31": __vite__wasmImport_0["__wbg__wbg_cb_unref_61db23ac97f16c31"],
"__wbindgen_init_externref_table": __vite__wasmImport_0["__wbindgen_init_externref_table"],
"__wbindgen_cast_0000000000000001": __vite__wasmImport_0["__wbindgen_cast_0000000000000001"],
"__wbindgen_cast_0000000000000002": __vite__wasmImport_0["__wbindgen_cast_0000000000000002"],
"__wbindgen_cast_0000000000000003": __vite__wasmImport_0["__wbindgen_cast_0000000000000003"],
"__wbindgen_cast_0000000000000004": __vite__wasmImport_0["__wbindgen_cast_0000000000000004"],
"__wbindgen_cast_0000000000000005": __vite__wasmImport_0["__wbindgen_cast_0000000000000005"],
"__wbindgen_cast_0000000000000006": __vite__wasmImport_0["__wbindgen_cast_0000000000000006"],
"__wbindgen_cast_0000000000000007": __vite__wasmImport_0["__wbindgen_cast_0000000000000007"],
"__wbindgen_cast_0000000000000008": __vite__wasmImport_0["__wbindgen_cast_0000000000000008"],
"__wbindgen_cast_0000000000000009": __vite__wasmImport_0["__wbindgen_cast_0000000000000009"],
"__wbindgen_cast_000000000000000a": __vite__wasmImport_0["__wbindgen_cast_000000000000000a"],
"__wbindgen_cast_000000000000000b": __vite__wasmImport_0["__wbindgen_cast_000000000000000b"] } }, __vite__wasmUrl);
export const {
  memory,
  deck_submit_language_stats,
  deck_submit_push_notifications,
  deck_advance_placement_session,
  deck_refresh_placement_session,
  deck_start_placement_session,
  get_placement_session_info,
  toggle_placement_word,
  __wbg_decksimulation_free,
  __wbg_dictionaryword_free,
  deck_add_gram_by_frequency_index,
  deck_get_gram_dictionary_count,
  deck_get_gram_dictionary_entries,
  deck_get_gram_dictionary_page,
  deck_get_placement_test,
  deck_get_sentence_list_for_category,
  deck_get_sentence_list_progress,
  deck_gram_dictionary_entry,
  deck_start_simulation,
  decksimulation_simulate_days,
  dictionaryword_audio_request,
  dictionaryword_display_text,
  dictionaryword_frequency_index,
  dictionaryword_gloss,
  dictionaryword_is_phrase,
  dictionaryword_prefix,
  dictionaryword_senses,
  dictionaryword_target_language,
  flashcard_view,
  follow_user,
  get_challenge_restrictions,
  get_follow_status,
  get_profile_by_id,
  get_profile_by_slug,
  get_sentence_list_navigation,
  get_transcription_review_definitions,
  get_user_language_stats_by_id,
  get_user_language_stats_by_slug,
  pronunciation_view,
  report_issue,
  report_issue_copy,
  unfollow_user,
  update_profile,
  account_copy,
  deck_due_words_view,
  deck_goals_screen_view,
  deck_home_screen_view,
  deck_review_screen_view,
  deck_stats_screen_view,
  frequency_knowledge_ticks,
  frequency_rank_label,
  get_daily_goal_options,
  get_language_metadata,
  next_review_line,
  onboarding_reduce,
  onboarding_start,
  onboarding_view,
  supabase_config,
  __wbg_ankideckplanner_free,
  anki_options_copy,
  ankideckplanner_finish,
  ankideckplanner_step,
  deck_anki_bundled_media,
  deck_anki_export_view,
  deck_start_anki_deck_plan,
  get_flashcard_disclosure,
  get_idle_study_state,
  mint_anki_deck,
  next_progress_milestone,
  should_show_challenge_tutorial,
  __wbg_audioresult_free,
  __wbg_clipresult_free,
  __wbg_deck_free,
  __wbg_lockupoffer_free,
  __wbg_releaseoffer_free,
  __wbg_reviewinfo_free,
  __wbg_weapon_free,
  audio_for_native_playback,
  audioresult_bytes,
  audioresult_voice_actor,
  autograde_transcription,
  autograde_transcription_llm,
  autograde_translation,
  clipresult_bytes,
  clipresult_critical_end_ms,
  clipresult_critical_start_ms,
  clipresult_duration_ms,
  clipresult_movie_id,
  clipresult_subtitles,
  deck_cache_challenge_audio,
  deck_change_sentence_list,
  deck_complete_placement_test,
  deck_get_accomplishment,
  deck_get_all_cards_summary,
  deck_get_best_movie_sentence_list,
  deck_get_best_pimsleur_sentence_list,
  deck_get_book_metadata,
  deck_get_current_tier,
  deck_get_current_week_progress,
  deck_get_daily_review_target,
  deck_get_daily_review_target_setting,
  deck_get_daily_streak,
  deck_get_frequency_knowledge_chart_data,
  deck_get_leeches,
  deck_get_lockup_offer,
  deck_get_manual_add_option,
  deck_get_manual_add_options,
  deck_get_movie_metadata,
  deck_get_movie_poster,
  deck_get_movie_stats,
  deck_get_no_cards_ready_info,
  deck_get_percent_of_words_known,
  deck_get_pimsleur_stats,
  deck_get_release_offer,
  deck_get_review_info,
  deck_get_sentence_list,
  deck_get_target_language,
  deck_get_today_reviews,
  deck_get_today_summary,
  deck_get_today_time_spent,
  deck_get_total_reviews,
  deck_get_xp,
  deck_has_taken_placement_test,
  deck_locked_count,
  deck_num_cards_added,
  deck_review_card,
  deck_sentence_posters,
  deck_set_daily_review_target,
  deck_study_plan_was_recently_accepted,
  deck_transcribe_sentence,
  deck_translate_sentence_perfect,
  deck_translate_sentence_wrong,
  get_ai_server_url,
  get_app_version,
  get_audio,
  get_audio_cache_version,
  get_available_courses,
  get_clip,
  get_clip_manifest_version,
  get_showcase_data,
  get_temp_audio,
  gram_to_display_string,
  invalidate_audio_cache,
  invalidate_clip_cache,
  lockupoffer_keep_preview,
  lockupoffer_lock_event,
  refresh_clip_manifest,
  releaseoffer_release_count,
  releaseoffer_release_preview,
  releaseoffer_unlock_event,
  reviewinfo_due_but_audio_pending_count,
  reviewinfo_due_but_banned_count,
  reviewinfo_due_but_locked_count,
  reviewinfo_due_count,
  reviewinfo_future_count,
  reviewinfo_total_count,
  test_opfs,
  weapon_add_deck_event,
  weapon_add_deck_event_at,
  weapon_add_deck_selection_event,
  weapon_add_remote_event,
  weapon_cache_language_pack,
  weapon_create,
  weapon_deck_inputs_key,
  weapon_device_id,
  weapon_get_deck_selection_state,
  weapon_get_deck_state,
  weapon_get_stream_num_events,
  weapon_get_sync_state,
  weapon_get_timestamp_of_earliest_unsynced_event,
  weapon_is_language_pack_fully_loaded,
  weapon_load_from_local_storage,
  weapon_load_language_pack,
  weapon_load_language_pack_core,
  weapon_num_events,
  weapon_num_events_on_remote_as_of_last_sync,
  weapon_request_deck_selection,
  weapon_request_reviews,
  weapon_reviews_history_known,
  weapon_subscribe_to_stream,
  weapon_sync,
  weapon_sync_status,
  weapon_sync_with_supabase,
  weapon_unsubscribe,
  weapon_user_id,
  get_courses,
  __wbg_listenerkey_free,
  apply_translation_grade,
  failed_translation_review,
  find_closest_translation,
  get_translation_review_feedback,
  prepare_translation_review,
  translation_is_perfect,
  translation_resume,
  translation_start,
  translation_transition,
  translation_view,
  apply_transcription_grade,
  failed_transcription_review,
  prepare_transcription_submission,
  transcription_is_perfect,
  transcription_resume,
  transcription_start,
  transcription_transition,
  transcription_view,
  deck_load_start,
  deck_load_transition,
  deck_load_view,
  background_palette,
  definition_view,
  morphology_label,
  transcription_pending_slot,
  translation_pending_slot,
  sync_status_view,
  design_palette,
  wasm_bindgen__convert__closures_____invoke__hf77c2900517094ef,
  wasm_bindgen__convert__closures_____invoke__h7e284c0cf44142f9,
  wasm_bindgen__convert__closures_____invoke__h1c0cb91aab8c7a31,
  wasm_bindgen__convert__closures_____invoke__h88278c2c452cc491,
  wasm_bindgen__convert__closures_____invoke__hebb73f741132dc69,
  wasm_bindgen__convert__closures_____invoke__hd10514f9bd42e4f1,
  wasm_bindgen__convert__closures________invoke__hc901a27da5d8cc88,
  wasm_bindgen__convert__closures_____invoke__h0d88b2c4764eb564,
  __wbindgen_malloc,
  __wbindgen_realloc,
  __wbindgen_exn_store,
  __externref_table_alloc,
  __wbindgen_externrefs,
  __wbindgen_free,
  __wbindgen_destroy_closure,
  __externref_table_dealloc,
  __wbindgen_start,
} = __vite__wasmModule;
